import React, { useCallback, useEffect, useState } from 'react'
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from './EmblaCarouselArrowButtons'
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import { Point } from '../atom/Point'

const EmblaCarousel = (props) => {
  const { options } = props
  const autoplayOptions = { delay: 3000, stopOnInteraction: false }
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    Autoplay(autoplayOptions),
  ])
  const [currentIndex, setCurrentIndex] = useState(0)

  const onNavButtonClick = useCallback((emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay
    if (!autoplay) return

    const resetOrStop =
      autoplay.options.stopOnInteraction === false
        ? autoplay.reset
        : autoplay.stop

    resetOrStop()
  }, [])

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi, onNavButtonClick)

  useEffect(() => {
    if (!emblaApi) return

    const handleSelect = () => {
      setCurrentIndex(emblaApi.selectedScrollSnap())
    }

    emblaApi.on('select', handleSelect)
    return () => emblaApi.off('select', handleSelect)
  }, [emblaApi])

  const calculateLeftPosition = () => {
    switch (currentIndex) {
      case 0:
        return '-0.1%'
      case 1:
        return '34%'
      case 2:
        return '67%'
      default:
        return '-0.1%'
    }
  }
  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          <div className="embla__slide">
            <div className="embla__slide__content">
              <section className="my-auto">
                <Point
                  pointWidth={51}
                  pointHeight={20}
                  pointRadius="15px"
                  pointMargin="0"
                />
                <b>전체 산업</b>
                <p>
                  보관, 유통, 포장, 운송 등&nbsp;
                  <br className="d-none d-md-block" />
                  고객 맞춤형 물류 솔루션과
                  <br />
                  스마트 물류 시스템으로 효율성을 높이며,
                  <br />
                  미래형 물류 산업을 선도합니다.
                </p>
              </section>
              <picture>
                <source srcSet="/carousel-1.webp" type="image/webp" />
                <img src="/carousel-1.png" alt="packaging" />
              </picture>
            </div>
          </div>
          <div className="embla__slide">
            <div className="embla__slide__content">
              <section className="my-auto">
                <Point
                  pointWidth={51}
                  pointHeight={20}
                  pointRadius="15px"
                  pointMargin="0"
                />
                <b>물류 시설 현황</b>
                <p>
                  서진로지텍은 4개의 대형 창고와&nbsp;
                  <br className="d-none d-md-block" />
                  넓은 포장 야드, 최신 설비로
                  <br />
                  수출입 화물의 효율적 관리를 제공하는&nbsp;
                  <br className="d-none d-md-block" />
                  종합 물류 서비스 기업입니다.
                </p>
              </section>
              <picture>
                <source srcSet="/carousel-2.webp" type="image/webp" />
                <img src="/carousel-2.png" alt="packaging" />
              </picture>
            </div>
          </div>
          <div className="embla__slide">
            <div className="embla__slide__content">
              <section className="my-auto">
                <Point
                  pointWidth={51}
                  pointHeight={20}
                  pointRadius="15px"
                  pointMargin="0"
                />
                <b>장비 현황</b>
                <p>
                  리치스테커, 지게차, 페이로우더, 포크레인을&nbsp;
                  <br className="d-none d-md-block" />
                  구비하고 있으며,
                  <br className="d-block d-md-none" /> 최첨단 장비를 통해&nbsp;
                  <br className="d-none d-md-block" />
                  다양한 물류 작업을 신속하고 정확하게&nbsp;
                  <br className="d-none d-md-block" />
                  수행합니다.
                </p>
              </section>
              <picture>
                <source srcSet="/carousel-3.webp" type="image/webp" />
                <img src="/carousel-3.png" alt="packaging" />
              </picture>
            </div>
          </div>
        </div>
      </div>
      <div className="embla__controls">
        <div className="position-relative my-auto">
          <img
            src="/white-line.svg"
            alt="white line"
            id="carousel-white-line"
          />
          <img
            src="/indigo-line.svg"
            alt="indigo line"
            id="carousel-indigo-line"
            style={{
              left: calculateLeftPosition(),
            }}
          />
        </div>
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      </div>
    </section>
  )
}

export default EmblaCarousel
